import { FeatureFlagDto } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagDto";
import { SocieteDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteDto";
import { EventBus } from "./EventBus";
import EventConstants from "./EventConstants";
import { ServicesFactoryInstance } from "./ServicesFactory";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";

export class FeatureFlagManager {
	public listeFeatureFlag?: FeatureFlagDto[] = undefined;

	public constructor() {
		EventBus.$on(EventConstants.SOCIETE_CHANGED, (data) => this.getListeFeatureFlag(data));
	}

	public getListeFeatureFlag(societe: SocieteDto): void {
		if (societe.NoIcare != undefined) {
			ServicesFactoryInstance.ParametresService.getListeFeatureFlag(
				(data) => {
					this.listeFeatureFlag = data;
					EventBus.$emit(EventConstants.FEATURE_FLAG_LOADED);
				},
				() => {
					this.listeFeatureFlag = undefined;
					EventBus.$emit(EventConstants.FEATURE_FLAG_LOADED);
				}
			);
		} else {
			EventBus.$emit(EventConstants.FEATURE_FLAG_LOADED);
		}
	}

	public hasFeatureFlag(featureFlag: FeatureFlagModuleEnum): boolean {
		return this.listeFeatureFlag != undefined && this.listeFeatureFlag.filter(f => f.Module == featureFlag && f.EstActive == true).length > 0;
	}
}

export const FeatureFlagManagerInstance: FeatureFlagManager = new FeatureFlagManager();



// WEBPACK FOOTER //
// ./src/components/Controls/FeatureFlagManager.ts